
module.exports.CONSTANTS = {
  STEP: {
    STATUS: {
      INIT: 'init',
      CANCELLED: 'cancelled',
      REJECTED: 'rejected',
      SIGNED: 'signed',
      SEND_TO_SIGN: 'sendToSign',
      ERROR: 'error',
      EXPIRED: 'expired',
      SIGNING: 'signing'
    },
    TYPES: {
      attendedSignStep: 'attendedSignStep',
      padSignStep: 'padSignStep',
      otpSignStep: 'otpSignStep',
      subFlows: 'subFlows',
      timeStampStep: 'timeStampStep',
      stampSignStep: 'stampSignStep',
      qrSignStep: 'qrSignStep',
      biometricSignStep: 'biometricSignStep',
      transactSignStep: 'transactSignStep',
      aproveStep: 'aproveStep',
      notificationStep: 'notificationStep',
      biometricOnBoardingStep: 'biometricOnBoardingStep',
      blockchainIdentitySignStep: 'blockchainIdentitySignStep'
    },
    DEFAULT_RETRY: 3,
    ACTIVITY: 'sign'
  },
  FLOW: {
    STATUS: {
      INIT: 'INIT',
      CANCELLED: 'cancelled',
      REJECTED: 'rejected',
      SIGNED: 'signed',
      SEND_TO_SIGN: 'sendToSign',
      ERROR: 'error',
      EXPIRED: 'expired'
    }
  },
  BUNDLE: {
    FILES_LIMIT: 30,
    STATUS: {
      INIT: 'INIT',
      CANCELLED: 'cancelled',
      REJECTED: 'rejected',
      SIGNED: 'signed',
      SEND_TO_SIGN: 'sendToSign',
      ERROR: 'error',
      READY: 'READY',
      LAUNCHING: 'launching',
      DELETED: 'deleted'
    }
  },
  DOCUMENT: {
    FILES_LIMIT: 10,
    STATUS: {
      INIT: 'INIT',
      CANCELLED: 'cancelled',
      REJECTED: 'rejected',
      SIGNED: 'signed',
      SEND_TO_SIGN: 'sendToSign',
      ERROR: 'error',
      EXPIRED: 'expired',
      DELETED: 'deleted'
    }
  },
  IDENTITY: {
    STATUS: {
      INIT: 'INIT',
      REGISTERED: 'REGISTERED',
      VERIFIED: 'VERIFIED',
      REJECTED: 'REJECTED'
    }
  },
  CSV: {
    NAME: 'name',
    DESCRIPTION: 'description',
    UPDATED_AT: 'updatedAt',
    FLOW_ID: 'flowId',
    FLOW_STATUS: 'status',
    TEMPLATE_ID: 'templateId',
    HASH: 'hash',
    STEP_ID: 'stepId',
    STEP_TYPE: 'stepType',
    STEP_STATUS: 'stepStatus',
    NAME_SUBFLOW: 'name_subflow',
    DESCRIPTION_SUBFLOW: 'description_subflow',
    UPDATED_AT_SUBFLOW: 'updatedAt_subflow',
    FLOW_ID_SUBFLOW: 'flowId_subflow',
    FLOW_STATUS_SUBFLOW: 'status_subflow',
    TEMPLATE_ID_SUBFLOW: 'templateId_subflow',
    STEP_ID_SUBFLOW: 'stepId_subflow',
    STEP_TYPE_SUBFLOW: 'stepType_subflow',
    STEP_STATUS_SUBFLOW: 'stepStatus_subflow',
    TAGS: 'tags',
    FLOW_SEND_TO_SIGN_AT: 'flow_createdAt',
    STEP_SEND_TO_SIGN_AT: 'step_createdAt',
    CREATOR: 'owner'
  },
  DEFAULT_FILE_SIZE: { // Syze in bytes
    MAX: 20971520,
    BULK_NOTIFICATION: 5242880
  },
  PDF_MIME: 'application/pdf',
  EXCEPTIONS: {
    UNEXPECTED_LAMBDA_EXCEPTION: {
      CODE: 'UnexpectedLambdaException',
      ERROR_SOCKET_TIMEOUT: 'invocation failed due to error socket timeout while invoking lambda function'
    },
    USER_LAMBDA_VALIDATION_EXCEPTION: {
      CODE: 'UserLambdaValidationException',
      PRETOKENGENERATION_FAILED: 'PreTokenGeneration failed with error '
    }
  },
  AMPLIFY_EVENTS_TYPE: {
    SIGN_IN: 'signIn',
    SIGN_UP: 'signUp',
    SIGN_OUT: 'signOut',
    SIGN_IN_FAILURE: 'signIn_failure',
    CONFIGURED: 'configured'
  },
  BUNDLE_ZIP_STATUS: {
    GENERATING: 'generating',
    READY: 'ready',
    INIT: 'init'
  },
  ROLES: {
    ADMIN: 'admin',
    EDITOR: 'editor',
    READER: 'reader',
    SIGNER: 'signer'
  }
};
